import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import Collapse from 'react-bootstrap/lib/Collapse';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../../Link/Link';
import messages from '../../../locale/messages';
import { DownArrowIcon } from '../../Common/Assets/SvgComponent/SiteAdminSvgIcon';
import s from './SideBar.css';

// Helper to determine if the current path is active
function isActive(location, path, matchType = 'exact') {
  if (!location || !path) return false;

  switch (matchType) {
    case 'exact':
      return location === path;
    case 'startsWith':
      return location.startsWith(path);
    case 'regex':
      try {
        const regex = new RegExp(path);
        return regex.test(location);
      } catch (err) {
        console.error('Invalid regex path:', path);
        return false;
      }
    default:
      return false;
  }
}

function SideMenuAccordion({ dataValue, location, onClick, intl }) {
  const { formatMessage } = intl;

  // Determine if any child path is active
  const isMenuActive = dataValue?.paths?.some(path =>
    isActive(location, path, dataValue.matchType || 'exact')
  );

  // Open menu if current location is active
  const [isOpen, setOpen] = useState(isMenuActive);

  useEffect(() => {
    if (isMenuActive) {
      setOpen(true);
    }
  }, [isMenuActive]);

  return (
    <div>
      <button onClick={() => setOpen(!isOpen)} className={cx(s.sideMenuListAccordionBtn, (isMenuActive && s.sideMenuListActive
      ), 'sideMenuListActiveBorderRTL')}>
        <span className={s.sideMenuListAccordionBtnIconContainer}>
          {dataValue?.icon}
        </span>
        <span className={s.sideMenuListAccordionBtnTextContainer}>
          {formatMessage(messages[dataValue?.label])}
        </span>
        <span className={cx(s.sideMenuListAccordionBtnArrow, isOpen && s.sideMenuListAccordionBtnActiveArrow)}>
          <DownArrowIcon />
        </span>
      </button>

      <Collapse in={isOpen}>
        <div>
          {dataValue?.data?.map((value, key) => {
            const activeLink = value?.activePaths?.some(path =>
              isActive(location, path, value.matchType || 'exact')
            );

            return (
              <Link
                key={key}
                to={value?.href}
                onClick={onClick}
                className={cx(s.sideMenuListAccordionCollapseList, (activeLink && s.sideMenuListActive), 'sideMenuListActiveBorderRTL')}
              >
                <span className={cx(s.sideMenuListAccordionCollapseListIcon, 'sideMenuListAccordionCollapseListIconRtl')}>{value?.icon}</span>
                <span className={s.sideMenuListAccordionCollapseListText}>{formatMessage(messages[value?.label])}</span>
              </Link>
            );
          })}
        </div>
      </Collapse>
    </div>
  );
}

export default injectIntl(withStyles(s)(SideMenuAccordion));